/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { JsonbType } from '@xilo-mono/form-contracts';
import moment from 'moment';

@Component({
  selector: 'xilo-mono-form-viewer-sdk-policy-modal',
  templateUrl: './sdk-policy-modal.component.html',
  styleUrls: ['./sdk-policy-modal.component.scss']
})
export class SDKPolicyModalComponent implements OnInit {
  policies: JsonbType[] = [];
  clients: JsonbType | JsonbType[];

  constructor(
    public dialogRef: MatDialogRef<SDKPolicyModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.policies = this.data.policies;
    this.clients  = this.data.client?.length ? this.data.client : [this.data.client];
  }

  saveData(data:JsonbType) {
    this.dialogRef.close({
      success: true,
      data
    });
  }

  closeModal(): void {
    this.dialogRef.close({ success: false });
  }

  returnPolicyTitle(policy:JsonbType) {
    let title = ''
    if (policy.PolicyNumber)   title = title.concat(`${policy.PolicyNumber}`)
    if (policy.PolicyTypeCode) title = title !== '' ? title.concat(`, ${policy.PolicyTypeCode}`) : title.concat(`${policy.PolicyTypeCode}`)
    else if (policy.LineTypeCode) title = title !== '' ? title.concat(`, ${policy.LineTypeCode}`) : title.concat(`${policy.LineTypeCode}`)
    if (policy.ExpirationDate) title = title !== '' ? title.concat(`, ${moment(policy.ExpirationDate).format('MM/DD/YYYY')}`) : title.concat(`${moment(policy.ExpirationDate).format('MM/DD/YYYY')}`)
    return title
  }
}
